import earcut from 'earcut';
export { earcut as default };